import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { useTranslation } from "react-i18next";

import { useStyles } from "./GlobalReleaseTicket.styles";
import { LinearProgress } from "./../LinearProgress/LinearProgress";
import { ToolTip } from "../ToolTip/ToolTip";
import { dateDifference, isObjectEmpty } from "./../../_helpers";
import { dateFormatAltHour, dateFormatNoTime } from "../../_constants";

const GlobalReleaseTicket = ({ data }) => {
  const classes = useStyles();
  const { t } = useTranslation(["fuseUpdates"]);

  const [deadDiff, setDeadDiff] = useState({ result: null, isExpired: false });

  useEffect(() => {
    function getData() {
      let current = moment().valueOf();
      let diff = dateDifference(current, data?.deadlineDateInMillis, "hours");
      setDeadDiff(diff);
    }
    getData();
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.releaseSection}>
        <div className={classes.sectionOne}>
          <span>{t("fuseUpdates:Updates.releases.globalRelease.version")}</span>
          <span className={classes.versionNumber}>{data?.version}</span>
        </div>
        <div className={classes.sectionTwo}>
          <div className={classes.subSection}>
            <span className={classes.subheading}>
              {t("fuseUpdates:Updates.releases.detail.uploadDate")}
            </span>
            <span className={classes.font}>
              {moment(data?.uploadedDate).format(dateFormatNoTime)}
            </span>
            <span className={classes.align}>
              {moment(data?.uploadedDate).format("h:mm A")}
            </span>
          </div>
          <div className={classes.subSection}>
            <span className={classes.subheading}>
              {t("fuseUpdates:Updates.releases.globalRelease.releaseDate")}
            </span>
            <span className={classes.font}>
              {moment(data?.releaseDateInMillis).format(dateFormatNoTime)}
            </span>
            <span className={classes.align}>
              {moment(data?.releaseDateInMillis).format("h:mm A")}
            </span>
          </div>
          <div className={classes.subSection}>
            <span className={classes.subheading}>
              {t("fuseUpdates:Updates.releases.detail.deadline")}
            </span>
            <span className={classes.font}>
              {data?.deadlineDateInMillis
                ? moment(data?.deadlineDateInMillis).format(dateFormatNoTime)
                : ""}
            </span>
            <span className={classes.align}>
              {data?.deadlineDateInMillis
                ? deadDiff.isExpired
                  ? t("common:dates.dayago", { day: deadDiff.result })
                  : t("common:dates.dayleft", { day: deadDiff.result })
                : ""}
            </span>
          </div>
          {data?.adoption && !isObjectEmpty(data?.adoption) ? (
            <div className={classes.subSection}>
              <span className={classes.subheading}>
                {t("fuseUpdates:Updates.releases.globalRelease.adoption")}
                <span className={classes.infoicon}>
                  <ToolTip
                    label={t(
                      "fuseUpdates:Updates.releases.globalRelease.adoptionTemp",
                      {
                        time: moment(data?.adoption.updatedAtInMillis).format(
                          dateFormatAltHour
                        ),
                      }
                    )}
                  ></ToolTip>
                </span>
              </span>
              <span className={classes.alignMarginBottom}>
                <LinearProgress
                  value={
                    (data?.adoption.installed / data?.adoption.audience) * 100
                  }
                ></LinearProgress>
              </span>
              <span className={classes.alignMarginTop}>
                {data?.adoption.installed} / {data?.adoption.audience}&nbsp;
                {t("fuseUpdates:Updates.releases.globalRelease.installed")}
              </span>
            </div>
          ) : (
            <div className={classes.subSection}></div>
          )}
        </div>
      </div>
    </div>
  );
};

GlobalReleaseTicket.propTypes = {
  data: PropTypes.object,
};

export { GlobalReleaseTicket };
